import api from "./api";

export const GetMetricasPedidos = async () => {
  try {
    const response = await api.get(`/pedidos/metricas`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const listarPedidosPorStatus = async (page, status) => {
  try {
    const pedidos = await api.post(`/pedidos/status?page=${page}`, {
      status,
    });
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const listarPedidosByDateRange = async (iniDate, fimDate, estabelecimentoId) => {
  try {
    let page = 1;
    let pages = 2;
    let pedidos = [];
    while (page < pages) {
      const select =
        "-avaliacao -distancia -itens_trocados -itens_peso_alterado -itens_quantidade_alterada -itens_retirados -itens_adicionados_separacao -opcao_falta_estoque -numeroRepasses";
      const query = `page=${page}&initial_date=${new Date(
        iniDate,
      ).toISOString()}&final_date=${new Date(fimDate).toISOString()}&select=${select}`;
      const url = estabelecimentoId
        ? `/estabelecimentos/${estabelecimentoId}/pedidos/status?${query}`
        : `/pedidos/status?${query}`;
      const { data } = await api.post(url, {
        status: ["entregue", "entrega_finalizada"],
      });
      page += 1;
      if (data) {
        pages = data.pages;
        pedidos.push(...data.docs);
      }
    }
    return pedidos;
  } catch (error) {
    throw error;
  }
};

export const listarPedidosPorStatusEstabelecimento = async (
  page,
  estabelecimento_id,
  status,
) => {
  try {
    const pedidos = await api.post(
      `estabelecimentos/${estabelecimento_id}/pedidos/status?page=${page}`,
      {
        status,
      },
    );
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const AlterarPedido = async (id_pedido, data) => {
  try {
    const pedidos = await api.put(`/pedidos/${id_pedido}`, data);
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const cancelarPedidoApi = async (id_pedido, data) => {
  try {
    const response = await api.put(`/pedidos/${id_pedido}/cancelar`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ListarPedidos = async (page = 1) => {
  try {
    const pedidos = await api.get(`pedidos?page=${page}`);
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const despacharEntregadorSelecionado = async (id_pedido, id_entregador) => {
  try {
    const response = await api.get(
      `/pedidos/${id_pedido}/entregador/${id_entregador}/despachar`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
